var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"main--text",attrs:{"color":"primary","dark":""}},[_c('v-toolbar-title',{staticClass:"title--text"},[_vm._v("Prosense")]),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }